import { Box, Typography } from '@mui/material';
import logoIcon from 'assets/images/logo-icon.svg';
import { InterruptionDirection } from '../../../types';

type InterruptionsEmergencyCardHeaderProps = {
  direction: InterruptionDirection;
  isUrgentTimer: boolean;
  ttlLabel: string;
};

const HEADER_SX = {
  alignItems: 'flex-start',
  display: 'flex',
  justifyContent: 'space-between',
} as const;

const TITLE_SX = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
} as const;

const LOGO_SX = {
  height: 20,
  width: 20,
} as const;

const TIMER_SX = {
  alignItems: 'center',
  display: 'flex',
  gap: 0.5,
  justifyContent: 'center',
} as const;

const TIMER_VALUE_SX = {
  borderRadius: 1,
  color: 'common.white',
  flexShrink: 0,
  fontSize: 10,
  fontVariantNumeric: 'tabular-nums',
  fontWeight: 600,
  lineHeight: 1,
  minWidth: 24,
  px: 0.75,
  py: 0.75,
  textAlign: 'center',
} as const;

const DIRECTION_LABEL = {
  [InterruptionDirection.Incoming]: 'Interruption',
  [InterruptionDirection.Outgoing]: 'Awaiting callback from',
} as const;

const InterruptionsEmergencyCardHeader = ({
  direction,
  isUrgentTimer,
  ttlLabel,
}: InterruptionsEmergencyCardHeaderProps) => {
  const timerColor = isUrgentTimer ? 'error.main' : 'success.main';
  const [ttlMinutesLabel = '00', ttlSecondsLabel = '00'] = ttlLabel.split(':');

  return (
    <Box component="header" sx={HEADER_SX}>
      <Box component="span" sx={TITLE_SX}>
        <Box component="img" src={logoIcon} alt="Logo" sx={LOGO_SX} />

        <Typography variant="subtitle2" color="textPrimary">
          {DIRECTION_LABEL[direction]}
        </Typography>
      </Box>

      <Box sx={TIMER_SX}>
        <Box sx={{ ...TIMER_VALUE_SX, bgcolor: timerColor }}>{ttlMinutesLabel}</Box>
        <Box component="span" sx={{ flexShrink: 0, textAlign: 'center', width: 4 }}>
          :
        </Box>
        <Box sx={{ ...TIMER_VALUE_SX, bgcolor: timerColor }}>{ttlSecondsLabel}</Box>
      </Box>
    </Box>
  );
};

export default InterruptionsEmergencyCardHeader;
